export default {"item":"hMnrH","pagination":"xlkqY"};